<section>
  <app-form-header (onSave)="onSubmit()" (onCancel)="cancel()" [cancelText]="'COMMON.BACK_BUTTON'"></app-form-header>
  <div class="row form-group">
    <div class="help-text col-12">
      {{ 'CONTROL_DATA.EDIT_FORM_DESCRIPTION' | translate }}
    </div>
  </div>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_CONTROL_DATA' | translate }}</h5>
      <div class="row form-group">
        <div class="col-12 col-sm-6 col-md-3">
          <app-text-box [control]="form.controls['formNumber']"></app-text-box>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <app-check-box [control]="contentForm.controls['fK205_Borttag']"></app-check-box>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <app-check-box [control]="contentForm.controls['fK210_Rattelse']"></app-check-box>
        </div>
        <div class="col-12">
          <app-text-area [control]="form.controls['comment']"></app-text-area>
        </div>
      </div>
      @if (!contentForm.controls['fK205_Borttag'].value) {
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_OBJECT' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK630_BostRattBeteckning']"></app-text-box>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_INDIVIDUAL' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-select [control]="contentForm.controls['fK646_GemensamIndividuell']" [itemsSource]="individualSelection"></app-select>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_TRANSFER' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-local-date-picker [control]="contentForm.controls['fK631_Overlatelsedatum']"></app-local-date-picker>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-numeric-box [control]="contentForm.controls['fK632_OverlatenAndel']" [decimals]="2"></app-numeric-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-check-box [control]="contentForm.controls['fK633_OverlatelseArvBodeln']"></app-check-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK634_Overlatelsepris']" [round]="true"></app-money-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK635_InreRepFondOverlatelse']"></app-money-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK636_Kapitaltillskott']" [round]="true"></app-money-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK639_Tillaggskopeskilling']" [round]="true"></app-money-box>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_SELLER' | translate }}</h5>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK215_Inkomsttagare']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK216_Fornamn']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK217_Efternamn']"></app-text-box>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK224_AnnatIDNr']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK226_OrgNamn']"></app-text-box>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK218_Gatuadress']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK228_Gatuadress2']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK219_Postnummer']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK220_Postort']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK221_LandskodPostort']"></app-text-box>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK222_Fodelsetid']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK230_FriAdress']"></app-text-box>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_UNTRUE_COMPANY' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-check-box [control]="contentForm.controls['fK638_OaktaBostadsftg']"></app-check-box>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_PURCHASE' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-local-date-picker [control]="contentForm.controls['fK640_Forvarvsdatum']"></app-local-date-picker>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-check-box [control]="contentForm.controls['fK642_ForvarvArvBodeln']"></app-check-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK643_Forvarvspris']" [round]="true"></app-money-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK644_InreRepFondForvarv']" [round]="true"></app-money-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-money-box [control]="contentForm.controls['fK645_AndelBRFFormogenhet1974']" [round]="true"></app-money-box>
          </div>
        </div>
        <h5>{{ 'COOPERATIVE_HOUSING.KU55.SECTION_HEADER_TIN' | translate }}</h5>
        <div class="row form-group">
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK076_LandskodTIN']"></app-text-box>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <app-text-box [control]="contentForm.controls['fK252_TIN']"></app-text-box>
          </div>
        </div>
      }
    </form>
  }
</section>
